import { render, staticRenderFns } from "./RejectionBtnDialog.vue?vue&type=template&id=30f3ee99"
import script from "./RejectionBtnDialog.vue?vue&type=script&lang=js"
export * from "./RejectionBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports